/** 节点配置表单字段名（独立模块，避免 nodeFields ↔ masterGroupForm 循环依赖） */
export const MASTER_NODES_FIELD = 'masterNodes';
export const WORKER_NODES_FIELD = 'workerNodes';
export const INFERENCE_SYSTEM_FIELD = '_inferenceSystem';
export const INFERENCE_SERVICE_FIELD = '_inferenceService';
export const MASTER_SYSTEM_DISK_FIELD = 'master.systemDiskSize';
export const WORKER_SYSTEM_DISK_FIELD = 'worker.systemDiskSize';
/** 系统盘计价厂商设备（与 SystemDiskSizeBlock paths.pricing 对齐） */
export const MASTER_SYSTEM_DISK_PRICING_FIELD = 'masterSystemDiskPricing';
export const WORKER_SYSTEM_DISK_PRICING_FIELD = 'workerSystemDiskPricing';
/** 系统盘默认大小（Gi），与 Slider 最小值一致 */
export const DEFAULT_SYSTEM_DISK_SIZE_GI = 10;
/** UI：网关节点 JSON（0/1 项） */
export const GATEWAY_NODES_FIELD = 'gatewayNodes';
/** UI：网关节点系统盘 Gi */
export const GATEWAY_SYSTEM_DISK_FIELD = 'gateway.systemDiskSize';
/** UI：网关节点系统盘计价选型 */
export const GATEWAY_SYSTEM_DISK_PRICING_FIELD = 'gatewaySystemDiskPricing';
